import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { FolderExportDocumentService } from '../store/services/folder-export-document.service'
import { ExcelOutputType, FolderExportModalConfig } from './folder-export-modal-config'

@Component({ selector: 'folder-export-modal', templateUrl: './folder-export-modal.component.html' })
export class FolderExportModalComponent {
  isExcelStep = false

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FolderExportModalConfig,
    public dialogRef: MatDialogRef<FolderExportModalComponent>,
    public dialog: MatDialog,
    private exportService: FolderExportDocumentService
  ) {}

  exportToWordDoc() {
    this.exportService.exportToDoc(this.data.folder.id, this.data.folder.name)
    this.dialogRef.close()
  }

  exportToExcel(type: ExcelOutputType) {
    const { id, name } = this.data.folder

    switch (type) {
      case ExcelOutputType.EXCEL:
        this.exportService.exportToExcel(id, name)
        break
      case ExcelOutputType.DEPARTMENT_HOURS:
        this.exportService.exportDepartmentsHoursXlsxTemplate(id, name)
        break
    }

    this.isExcelStep = false
    this.dialogRef.close()
  }

  protected readonly ExcelOutputType = ExcelOutputType
}
